import { Outlet } from "react-router-dom";
import Biographies from "pages/Admin/ManageBiographies/Biographies";
import ReportBiographies from "pages/Admin/ManageBiographies/ReportedBiographies";
import adminRouteMap from "routeControl/adminRouteMap";

export default function route() {
  return [
    {
      path: adminRouteMap.MANAGE_BIOGRAPHIES.path,
      private: true,
      name: "Manage Biographies",
      key: adminRouteMap.MANAGE_BIOGRAPHIES.path,
      belongsToSidebar: true,
      icon: adminRouteMap.MANAGE_BIOGRAPHIES.icon,
      element: <Outlet />,
      children: [
        {
          path: adminRouteMap.BIOGRAPHIES.path,
          private: true,
          name: "Biographies",
          key: adminRouteMap.BIOGRAPHIES.path,
          belongsToSidebar: true,
          element: <Biographies />,
        },
        {
          path: adminRouteMap.REPORT_BIOGRAPHIES.path,
          private: true,
          name: "Reported Biographies",
          key: adminRouteMap.REPORT_BIOGRAPHIES.path,
          belongsToSidebar: true,
          element: <ReportBiographies />,
        },
      ],
    },
  ];
}
